<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M9 12h3.75M9 15h1.5M9 18H10.5M20.25 7.5l-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h8.25l2.25-3.75H8.25L10 11.25ZM6.375 7.5h11.25"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round" 
      stroke-width="1.5"
      d="M5.625 3.75H9a.375.375 0 0 1 .375.375v3.75"
    />
  </svg>
</template>